export default [
    'education',
    'vehicle_insurance',
    'electricity',
    'telephone_services',
    'water_and_public_services',
    'heating_fuels_other',
    'natural_gas',
    'media_hardware_and_services',
  ]